import { colorPalette } from '@shared/config/colorsConfig';
import { typography } from '@shared/config/typographyConfig';

export const CHAT_BUBBLE = {
    incoming: { background: colorPalette.gray[200], border: colorPalette.gray[300], radius: [12, 12, 12, 4] },
    outgoing: { background: colorPalette.secondary[100], border: colorPalette.secondary[300], radius: [12, 12, 4, 12] },
    borderWidth: 1,
    paddingHorizontal: 16,
    paddingVertical: 12,
    openingOpacity: 0.6,
} as const;

export const CHAT_MESSAGE_TEXT_STYLE = {
    fontSize: typography.fontSize.md,
    lineHeight: typography.lineHeight.md,
    flexShrink: 1,
} as const;

export const CHAT_ATTACHMENT_TEXT_STYLE = {
    ...CHAT_MESSAGE_TEXT_STYLE,
    textDecorationLine: 'underline',
} as const;
